import axios from 'axios';

const ipApiService = async (responseCallback, errorCallback) => {
  await axios.get('https://ipapi.co/json/').then(responseCallback).catch(errorCallback);
};

export default ipApiService;
